<template>
    <div class="container mx-auto px-4">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">{{ group.name }}</h1>

        <c-control-text class="mx-auto text-center w-96" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="name" required
                        v-bind:invalid="!!requestStore.errors?.name"
                        v-bind:label="__('Megnevezés')"
                        v-model="group.name"
        />

        <c-control-tag class="mt-8 mx-auto text-center w-96" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="members"
                       v-bind:invalid="!!requestStore.errors?.members"
                       v-bind:label="__('Felhasználók')"
                       v-bind:label-field="(data) => data.lastname + ' ' + data.firstname + ' (' + data.email + ')'"
                       v-bind:source-get="userGet"
                       v-bind:source-search="userSearch"
                       v-model="group.members"
        />

        <c-control-number class="mt-8 mx-auto text-center w-96" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="discount" placeholder="10" required
                          v-bind:invalid="!!requestStore.errors?.discount"
                          v-bind:label="__('Kedvezmény (%)')"
                          v-bind:min="1"
                          v-model="group.discount"
        />

        <c-control-toggle class="mt-8 text-center" class-field-wrapper="mx-auto" name="is_webshop_enabled"
                          v-bind:invalid="!!requestStore.errors?.is_webshop_enabled"
                          v-bind:label="__('Webshop?')"
                          v-model="group.is_webshop_enabled"
        />

        <c-control-toggle class="mt-8 text-center" class-field-wrapper="mx-auto" name="is_active"
                          v-bind:invalid="!!requestStore.errors?.is_active"
                          v-bind:label="__('Aktív?')"
                          v-if="!group.is_default"
                          v-model="group.is_active"
        />

        <c-button class="bg-slate-800 border-2 border-slate-800 font-semibold hover:bg-highlight hover:border-highlight mb-4 mt-8 mx-auto normal-case px-4 py-2 rounded-none table text-center !text-lg text-white transition-colors w-48"
                  v-on:click="submit"
        >
            {{ __('Mentés') }}
        </c-button>
    </div>
</template>

<script setup lang="ts">
    import { isRef, onMounted, ref } from 'vue';
    import { useRoute } from 'vue-router';
    import {
        CButton,
        CControlNumber,
        CControlTag,
        CControlText,
        CControlToggle,
    } from '@teamfurther/cinderblock';
    import UserGroupRepository from '../../repositories/UserGroupRepository';
    import UserRepository from '../../repositories/UserRepository';
    import { useRequestStore } from '../../stores/request';

    const route = useRoute();
    const group = ref({});
    const groupId = route.params.group;
    const requestStore = useRequestStore();
    const userGroupRepository = new UserGroupRepository();
    const userRepository = new UserRepository();

    async function submit() {
        await userGroupRepository.update(groupId, group.value, {
            include: ['members']
        });
    }

    async function userGet(user) {
        if (isRef(user) && user.value) {
            return await userRepository.show(user.value.id);
        } else if (user && user.id) {
            return await userRepository.show(user.id);
        } else {
            return null;
        }
    }

    async function userSearch(val) {
        return await userRepository.index({
            filters : {
                search: val
            }
        });
    }

    onMounted(async () => {
        group.value = await userGroupRepository.show(groupId, {
            include: ['members']
        });
    });
</script>
